import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconArrowTopGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <polygon
        points="20.11 17.03 13.25 10.16 6.39 17.03 4.97 15.61 13.25 7.34 21.53 15.61 20.11 17.03"
        fill={fillColor}
      />
    </g>
  );
};

export const IconArrowTopSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.5 26.5"
      {...(props.svg ?? {})}
    >
      <IconArrowTopGroup {...props} />
    </svg>
  );
};
